import { css, cx } from 'linaria';
import { cssTheme } from '@uds/theme-utils';
import { Colorways } from '@uds/colorway';

const root = css`
  --border-top-color: ${cssTheme.palette.rgb.grey06};
  border-top: 2px solid rgba(var(--border-top-color), 0.2);
  display: flex;
  flex-direction: column;
  transition: padding-bottom var(--transition-duration) ease-in-out;
`;

const first = css`
  border-top: 0px;
`;

const active = css`
  padding-bottom: ${cssTheme.gu2};
`;

const primaryAgainst = css`
  --border-top-color: ${cssTheme.palette.rgb.primaryContrast};
`;

const highlightAgainst = css`
  --border-top-color: ${cssTheme.palette.rgb.highlightContrast};
`;

export const getClassNames = ({ isFirst, isActive, colorway }: { isFirst: boolean; isActive: boolean; colorway: Colorways }) => {
  return {
    root: cx(
      root,
      isFirst && first,
      isActive && active,
      colorway === Colorways.PRIMARY && primaryAgainst,
      colorway === Colorways.HIGHLIGHT && highlightAgainst,
    ),
  }
}